import React from 'react';

// The Everlabs logo + wordmark in the app header. Links back to the projects
// index. Shared by ProjectsListPage and ProjectShowPage so the branding and
// its home link stay defined in one place.
export default function HeaderBrand() {
  return (
    <a
      href="/"
      className="flex items-center gap-2.5"
      style={{ textDecoration: 'none' }}
    >
      <div style={{
        width: 22, height: 22, borderRadius: 5, background: '#1A1A1A',
        color: '#E63946', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 800, fontSize: 13, letterSpacing: '-0.04em'
      }}>e</div>
      <div className="text-[13px] font-semibold tracking-tight" style={{ color: '#1A1A1A' }}>
        Everlabs
      </div>
    </a>
  );
}
